import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { rejects } from 'assert';
import { isNullOrUndefined } from 'util';
import ApplicationData from '../../app/aApplicationData'

class ProdottoTable extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoTable.jsx] ';
        // this.detailsOnClick = this.detailsOnClick.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            { field: 'nomeVersione', title: i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione'), sortable: 'true' },
            { field: 'inizioValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.INIZIO', 'Inizio'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'fineValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.FINE', 'Fine'), sortable: 'true', formatter: this.dateFormatterShort },
            // { field: 'numEmissioni', title: 'Emissioni', sortable: 'true' },
            { field: 'stato', title: i18n('ARM_CORE_PRODUCT.SHARED.STATO', 'Stato'), sortable: 'true', formatter: this.statoProdottoFormatter },
            { field: 'idMicroCategoria', title: i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro Categoria'), visible: !this.props.source && this.props.source !== "gruppoProdottoDetails", sortable: 'true', formatter: this.microCategoriaFormatter },
            { field: 'prodottoCmpPojo.compagnia.denominazione', title: i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia'), sortable: 'true' },
            // { field: 'updateDate', title: 'Ultima Modifica', formatter: this.dateFormatter, sortable: 'true' },
            // { field: 'updateUser', title: 'Utente Ultima Modifica', sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.rows !== null && this.props.rows !== undefined) {

            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
        }
    }
    microCategoriaFormatter(value, row, index) {

        console.log(this.componentName + "microCategoriaFormatter:" + index);
        if (!isNullOrUndefined(row) && !isNullOrUndefined(row.microCategoria)) {
            return row.microCategoria.nome;

        }
        return '-'
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    statoProdottoFormatter(value, row, index) {
        console.log(this.componentName + ' statoProdottoFormatter index: ' + index);

        if (value !== undefined && value !== null) {
            let title = ApplicationData.domainVal('AI_STATO_PRODOTTO', value, value).desDom;
            if (value === 'LAV') {  // lavorazzione
                return "<i class='fas fa-spinner' title='" + title + "'></i>";
            } else if (value === 'PUBB') {  // pubblicato
                return "<i class='far fa-check-circle' title='" + title + "'></i>";
            }
            return " ";
        }

        return '-';
    }

    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        if (!isNullOrUndefined(this.props.source) && this.props.source === "prodottoDetails") {
            this.props.changeSelectedTab('home-tab').then(
                resolve => {
                    this.props.getProdottoDetails(row.id);
                },
                reject => {
                    console.log(this.componentName + "getProdottoDetails  KO");
                }
            );

        } else if (!isNullOrUndefined(this.props.source) && this.props.source === "prodottoOrigineDetails") {
            this.props.history.push({ pathname: '/prodotto/details', state: { id: row.id, origine: true } });
        }
        else {
            this.props.history.push({ pathname: '/prodotto/details', state: { id: row.id } });
        }

    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div>

                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getProdottoDetails(id) {
            return dispatch(ProdottoActions.getProdottoDetails(id));
        },
        changeSelectedTab(idTab) {
            return dispatch(ProdottoActions.changeSelectedTab(idTab));
        },

    }
};

function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ProdottoTable);
